<template>
  <div class="panel-simple">
    <div class="header global-thead-dark">
      <div class="col-md-7">
        <span class="d-flex">
          Informaci&oacute;n General del Proceso de Determinaci&oacute;n de
          Elegibilidad
        </span>
      </div>
      <div class="col-md-5">
        <span class="d-flex">
          A&ntilde;o Acad&eacute;mico: {{ this.value.academicYearDesc }}
        </span>
      </div>
    </div>

    <div class="container-fluid bg-rectangle-gradiant" />

    <ValidationObserver ref="observer" name="elegibility">
      <div class="row custom-panel-row-without-selector px-3 mx-0 pb-5 mb-3">
        <div class="col-md-7 col-sm-12 info">
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <span>
                <b>Fecha</b>
              </span>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDatePicker
                  v-model="value.academicyearfordate"
                  :max-date="disabledDatesAfter"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs['fecha']"
                  class="custom-datetime-picker-container custom-datetime-picker-container-grey"
                  @input="onSelectedDate"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div
          class="col-md-5 col-sm-12 info w-100 ml-n3 ml-md-n0 ml-sm-n3 mt-2 mt-md-0 mt-sm-2"
        >
          <ValidationProvider v-slot="{ errors }" rules="required">
            <CustomRadioGroup
              v-model="value.changeImpediment"
              is-inline
              label="¿Cambia el impedimento?"
              name="inputs"
              :options="radioButtonsOptions"
              :error="errors[0]"
              :is-disabled="disabled"
              :custom-error-msg="errorMsgs['impedimento']"
              @input="updateRadioBtnInformation"
            />
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomRadioGroup from '@/components/common/CustomRadio';
import alertMixin from '@/mixin/alert.mixin';

export default {
  name: 'EligibilityDetermination',
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return new {
          evaluationDate: null,
          academicYearId: null,
          academicYearDesc: null,
          academicYear: null,
          impedimentChangeFlag: false,
        }();
      },
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    CustomDatePicker,
    ValidationProvider,
    ValidationObserver,
    CustomRadioGroup,
  },
  data() {
    return {
      disabledDatesAfter: new Date(Date.now()),
      errorMsgs: {
        fecha: 'Fecha es requerida para completar el proceso. (23028)',
        impedimento:
          'Favor de contestar si cambió <br /> el Impedimento del estudiante.',
      },
      radioButtonsOptions: [
        { label: 'Si', value: true },
        { label: 'No', value: false },
      ],
    };
  },
  computed: {
    selectedStudentSieId() {
      return this.$store.getters.SelectedStudent.studentId;
    },
  },
  methods: {
    async updateRadioBtnInformation(value) {
      if (value === true) {
        const isValid = await this.hasTriannualEvaluation();
        if (!isValid) {
          this.value.changeImpediment = false;
          return;
        }
      }
    },
    onSelectedDate(date) {
      if (date) {
        this.$ApiGet(
          process.env.VUE_APP_URL_API +
            '/api/academicyears/getacademicyearfordate',
          { date: date }
        ).then((response) => {
          this.value.academicYearId = response.data.id;
          this.value.academicYearDesc = response.data.description;
          this.value.evaluationDate = this.academicyearfordate;
          this.value.academicYear = response.data.year;
        });
      }
    },
    async hasTriannualEvaluation() {
      const { data: validationResult } = await this.$ApiGet(
        `api/studentevaluation/hastriannualevaluation/${this.selectedStudentSieId}`
      );
      if (validationResult) {
        if (!validationResult.isValid) {
          this.ShowToast('Error', validationResult.message, 'error');
          return false;
        }
      }
      return true;
    },
  },
  mounted() {
    this.$emit('getRef', 'elegibility', this.$refs.observer);
  },
};
</script>

<style scoped>
.custom-panel-row-without-selector {
  background: #fafbfa 0% 0% no-repeat padding-box;
}
</style>
